import { Component, Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'empty-chat',
  templateUrl: './empty-chat.component.html',
  styleUrls: ['./empty-chat.component.css'],
})
@Injectable()
export class EmptyChatComponent implements OnInit {
  user: any = {
    name: '',
  };

  routers = [
    {
      url: '/settings',
      name: 'Cấu hình',
    },
    {
      url: '/customer',
      name: 'Thêm thành viên mới',
    },
    {
      url: '/customer',
      name: 'Thêm liên hệ mới',
    },
    {
      url: '/',
      name: 'Hướng dẫn sử dụng',
    },
  ];

  ngOnInit(): void {
    if (localStorage.getItem('User')) {
      this.user = JSON.parse(localStorage.getItem('User'));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/empty-chat/empty-chat.component.ts